export default function ServiceLabFab({ size = 96 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 96 96" fill="none" aria-hidden="true">
      {/* matraz / equipo de prueba */}
      <path
        d="M40 20 H56 M44 20 V40 L30 66 A4 4 0 0 0 34 72 H62 A4 4 0 0 0 66 66 L52 40 V20"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinejoin="round"
      />
      {/* nivel de líquido (acento) */}
      <path d="M37 54 H59" stroke="#54B53C" strokeWidth="1.25" />
      <circle cx="44" cy="60" r="1.6" fill="#54B53C" />
      <circle cx="52" cy="64" r="1.6" fill="#54B53C" />
      {/* engranaje de fabricación */}
      <circle cx="70" cy="28" r="8" stroke="currentColor" strokeWidth="1.25" />
      <circle cx="70" cy="28" r="2.5" stroke="currentColor" strokeWidth="1.25" />
      <path
        d="M70 16 V20 M70 36 V40 M58 28 H62 M78 28 H82 M62 20 L65 23 M75 33 L78 36"
        stroke="currentColor"
        strokeWidth="1.25"
      />
    </svg>
  );
}
